<template>
  <div>
    <div v-if="selectedVideos.length > 0" class="upload-list">
      <div class="video upload-list__video sm" v-for="item in selectedVideos" :key="item.id" >
        <div class="video-overlay">
          <svgicon name="Close" class="video-close" @click="removeFromSelected(item)"></svgicon>
        </div>
        <video :src="item.original_video_url" :poster="item.thumbnail_url" alt="" v-if="item.thumbnail_url" muted></video>
        <img src="../../assets/img/img-processing.png" alt="" v-else>
      </div>
    </div>
    <div class="upload-list__empty sm" v-else>
      Here you can see selected videos
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "UploadListFooter",
    data() {
      return {
        progress: 10,
      }
    },
    computed: {
      ...mapGetters({
        selectedVideos: 'selectedVideos',
      }),
    },
    methods: {
      removeFromSelected(video) {
        this.$store.dispatch('removeSelectedVideo', video);
      },
    },
  }
</script>

<style lang="scss">

</style>

